// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueUser = (value) => ({
  type: actionTypes.SET_VALUE_USER,
  payload: value,
});

export const setActifUser = (actif) => ({
  type: actionTypes.SET_ACTIF_USER,
  payload: actif,
});
export const setRoleUser = (role) => ({
  type: actionTypes.SET_ROLE_USER,
  payload: role,
});

export const setDateUser = (date) => ({
  type: actionTypes.SET_DATE_USER,
  payload: date,
});

export const setCurrentPageUser = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_USER,
  payload: page,
});

export const setOrderUser = (order) => ({
  type: actionTypes.SET_ORDER_USER,
  payload: order,
});

export const setSortFieldUser = (field) => ({
  type: actionTypes.SET_SORT_FIELD_USER,
  payload: field,
});
